

// export default Layout;
// src/components/Layout.tsx
// import React, { useState } from "react";
// import Sidebar from "./Sidebar";
// import Header from "./Header";
// import DashboardPage from "../pages/DashboardPage";
// import ProductList from "../pages/ProductList";
// import { Routes, Route } from "react-router-dom";
// import "./Layout.css";
// import CreateProduct from "./CreateProduct";
// import SettingsPage from "./SettingsPage";
// import OrdersPage from "./OrdersPage";
// import Logout from "../pages/Logout";
// import CustomersPage from "./CustomersPage";

// const Layout: React.FC = () => {
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const toggleSidebar = () => setSidebarOpen((prev) => !prev);
//   const closeSidebar = () => setSidebarOpen(false);

//   return (
//     <div className={`layout-container ${sidebarOpen ? "sidebar-open" : ""}`}>
//       {/* ✅ Sidebar */}
//       <aside className={`sidebar-container ${sidebarOpen ? "open" : ""}`}>
//         <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
//       </aside>

//       {/* ✅ Overlay for mobile */}
//       {sidebarOpen && (
//         <div
//           className="sidebar-overlay d-lg-none"
//           onClick={closeSidebar}
//         ></div>
//       )}

//       {/* ✅ Main content area */}
//       <div className="main-container">
//         {/* ✅ Header receives the toggle function */}
//         <header className="header-container">
//           <Header onToggleSidebar={toggleSidebar} />
//         </header>

//         <main className="content-scroll-area p-3 p-md-4">
//           <Routes>
//             <Route path="/" element={<DashboardPage />} />
//             <Route path="/products" element={<ProductList />} />
//             <Route path="/add-product" element={<CreateProduct />} />
//             <Route path="/settings" element={<SettingsPage />} />
//             <Route path="/orders" element={<OrdersPage />} />
//             <Route path="/customers" element={<CustomersPage />} />
//             <Route path="/logout" element={<Logout />} />
//           </Routes>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Layout;



// src/components/LayoutPage.tsx

import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

import DashboardPage from "../pages/DashboardPage";
import ProductList from "../pages/ProductList";
import CreateProduct from "./CreateProduct";
import SettingsPage from "./SettingsPage";
import OrdersPage from "./OrdersPage";
import CustomersPage from "./CustomersPage";
import Logout from "../pages/Logout";

import "./Layout.css";

/* ===========================
   🔐 Role Types
=========================== */
type Role = "super_admin" | "admin" | "sub_admin";

/* ===========================
   🔐 Protected Route Component
=========================== */
interface ProtectedRouteProps {
  allowedRoles: Role[];
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles,
  children,
}) => {
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

/* ===========================
   🎯 Main Layout
=========================== */
const LayoutPage: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={`layout-container ${sidebarOpen ? "sidebar-open" : ""}`}>
      
      {/* Sidebar */}
      <aside className={`sidebar-container ${sidebarOpen ? "open" : ""}`}>
        <Sidebar
          isOpen={sidebarOpen}
          onClose={closeSidebar}
          role={user?.role}
        />
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay d-lg-none"
          onClick={closeSidebar}
        ></div>
      )}

      {/* Main Content */}
      <div className="main-container">
        <header className="header-container">
          <Header onToggleSidebar={toggleSidebar} />
        </header>

        <main className="content-scroll-area p-3 p-md-4">
          <Routes>

            {/* ✅ Super Admin Only */}
            <Route
              path="/"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]}>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            {/* ✅ Super Admin + Admin */}
            <Route
              path="/products"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <ProductList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-product"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <CreateProduct />
                </ProtectedRoute>
              }
            />

            {/* ✅ Super Admin + Admin + Sub Admin */}
            <Route
              path="/orders"
              element={
                <ProtectedRoute
                  allowedRoles={["super_admin", "admin", "sub_admin"]}
                >
                  <OrdersPage />
                </ProtectedRoute>
              }
            />

            {/* ✅ Super Admin Only */}
            <Route
              path="/customers"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]}>
                  <CustomersPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings"
              element={
                <ProtectedRoute allowedRoles={["super_admin"]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />

            <Route path="/logout" element={<Logout />} />

          </Routes>
        </main>
      </div>
    </div>
  );
};

export default LayoutPage;
